import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import InputBox from "../../../../FormElement/InputBox";

export interface ILabelSearchBoxProps {
  value?: string;
  onChange: (value: string) => void;
}

export const LabelSearchBox = ({ value, onChange }: ILabelSearchBoxProps) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`adminLocationAlertsPage.adminLocationAlertsList.controls.${key}`);

  const [locationName, setLocationName] = useState<string>(value || "");

  const handleLabelNameKeyPress = (
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (e.key === "Enter") {
      onChange(locationName);
    }
  };
  return (
    <InputBox
      value={locationName || ""}
      onChange={(value) => setLocationName(value)}
      onKeyPress={handleLabelNameKeyPress}
      placeholder={t("search_by_label")}
      isSearch={true}
      classNameContainer={"search-input"}
    />
  );
};
